import { ReactNode, FC } from "react";
import { IRef, Menu as BlueprintMenu } from "@blueprintjs/core";
import { cx, css } from "@emotion/css";
import { DataAttributes } from "../types";

type Props = {
  children: ReactNode;
  ulRef?: IRef<HTMLUListElement>;
  minWidth?: "inherit" | "auto" | `var(--spacing-${string})`; // default: inherited
  className?: string;
} & DataAttributes;

export const Menu: FC<Props> = ({
  ulRef,
  children,
  minWidth,
  className,
  ...dataAttributes
}: Props) => {
  const minWidthStyle = css`
    min-width: ${minWidth || "inherit"};
  `;

  return (
    <BlueprintMenu
      className={cx(minWidthStyle, className)} // Combine minWidthStyle and className
      ulRef={ulRef}
      {...dataAttributes}
    >
      {children}
    </BlueprintMenu>
  );
};
